/**
 *  项目的配置文件
 */
// export const apiUrl = 'https://dev-mall-pc.njsyue.com/';//接口请求地址
// export const mUrl = 'https://dev-mall-m.njsyue.com/'//移动端网页地址
// export const pcUrl = 'https://dev-mall-pc.njsyue.com/';
// export const title = '拾越演示商城';//浏览器顶部title
// export const kefuUrl ='https://dev-asus.njsyue.com'
// export const staAppid = 20005236;

export const apiUrl = 'https://store.asus.com.cn/';//接口请求地址
export const pcUrl = 'https://store.asus.com.cn/';//接口请求地址
export const mUrl = 'https://wap.asus.com.cn/'//移动端网页地址
export const title = '华硕商城';//浏览器顶部title
export const kefuUrl ='https://cs.njsyue.com';
export const staAppid = 20007138;

// export const apiUrl = 'https://debug-mall-pc.njsyue.com/';//接口请求地址
// export const mUrl = 'https://debug-mall-m.njsyue.com/'//移动端网页地址
// export const pcUrl = 'https://debug-mall-pc.njsyue.com/';//接口请求地址
// export const title = '拾越演示商城';//浏览器顶部title
// export const kefuUrl ='https://dev-asus.njsyue.com'

export const curLang = 'zh';//当前语言,zh:中文，若为其他语言，需要对应/src/assets/language下面的文件名

export const gdKey = '';//高德web-js key
export const gdSecurityCode = ''//高德web-js 安全密钥
export const statShowDebug = false;//是否开启统计的调试
var api = '/api/'  //baseURL

if (process.env.NODE_ENV === 'production') {
    api = apiUrl;
}
/** copyright *** slodon *** version-v4.6.2 *** date-2023-03-22 ***主版本v4.6.2**/

export const  apis=apiUrl;
// export const  apis=api;
